import React from 'react';
import styles from './DoughnutChartWithRoundLegendsCard.module.scss';

interface Legend {
  color: string;
  text: string;
  metric: string;
  metricColor: string;
}

interface DoughnutChartWithRoundLegendsCardProps {
  chartComponent?: React.ReactNode;
  legend1: Legend;
  legend2: Legend;
  backgroundColor: string;
  textColor: string;
}

const DoughnutChartWithRoundLegendsCard: React.FC<
  DoughnutChartWithRoundLegendsCardProps
> = ({ chartComponent, legend1, legend2, backgroundColor, textColor }) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.chartContainer}>{chartComponent}</div>
      <div className={styles.legendContainer}>
        <div className={styles.legend}>
          <span
            className={styles.circle}
            style={{ backgroundColor: legend1.color }}
          />
          <span className={styles.legendText} style={{ color: textColor }}>
            {legend1.text}{' '}
            <span
              className={styles.metric}
              style={{ color: legend1.metricColor }}
            >
              {legend1.metric}
            </span>
          </span>
        </div>
        <div className={styles.legend}>
          <span
            className={styles.circle}
            style={{ backgroundColor: legend2.color }}
          />
          <span className={styles.legendText} style={{ color: textColor }}>
            {legend2.text}{' '}
            <span
              className={styles.metric}
              style={{ color: legend2.metricColor }}
            >
              {legend2.metric}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default DoughnutChartWithRoundLegendsCard;
